// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubformSpecial_wrapper__8zFvA","main-description":"SubformSpecial_main-description__gH8SW","photo-description":"SubformSpecial_photo-description__17ckA"};